import { FormValidator } from "./components/FormValidator";
import { blocksSlider, clientSlider, demosSlider, fadeSlider, newsSlider, newsSliderv2, rewardsSlider } from "./components/sliders";
import { formContainerRedirect, headerBgClass, primaryMenu } from "./utils/helpers";
import Popup from "./utils/popup-window";

// Styles entry
export { }

// Minimal boilerplate JS
const onLoad = () => {
	const popup = new Popup();

	popup.init();

	primaryMenu();

	new FormValidator('.contact-us .wpcf7');
	new FormValidator('#popup-form-audit .wpcf7');
	new FormValidator('#popup-form-contacts .wpcf7');
	new FormValidator('#popup-form-tariffs .wpcf7');

	formContainerRedirect();

	window.addEventListener('scroll', headerBgClass);

	headerBgClass();

	clientSlider();
	newsSlider();
	newsSliderv2();
	demosSlider();
	blocksSlider();
	fadeSlider();
	rewardsSlider();
};

window.document.addEventListener('DOMContentLoaded', onLoad);
